import { Content, Portal } from '@radix-ui/react-hover-card';
import { forwardRef } from 'react';
import styled, { keyframes } from 'styled-components';
import { duration, easing } from 'ui/theme/motion';
import { HoverCardAlignment, HoverCardPlacements } from './HoverCard.constants';

const slideUpAndFade = keyframes`
	0% {
    opacity: 0;
		transform: translateY(2px);
	}
	100% {
		opacity: 1;
		transform: translateY(0);
	}
`;

const slideRightAndFade = keyframes`
	0% {
		opacity: 0;
		transform: translateX(-2px);
	}
	100% {
		opacity: 1;
		transform: translateX(0);
	}
`;

const slideDownAndFade = keyframes`
	0% {
		opacity: 0;
		transform: translateY(-2px);
	}
	100% {
		opacity: 1;
		transform: translateY(0);
	}
`;

const slideLeftAndFade = keyframes`
	0% {
		opacity: 0;
		transform: translateX(2px);
	}
	100% {
		opacity: 1;
		transform: translateX(0);
	}
`;

const StyledContent = styled(Content)`
  animation-duration: ${duration.slideover};
  animation-timing-function: ${easing.entrance};
  will-change: transform, opacity;

  &[data-side=${HoverCardPlacements.Top}] {
    animation-name: ${slideDownAndFade};
  }
  &[data-side=${HoverCardPlacements.Right}] {
    animation-name: ${slideLeftAndFade};
  }
  &[data-side=${HoverCardPlacements.Bottom}] {
    animation-name: ${slideUpAndFade};
  }
  &[data-side=${HoverCardPlacements.Left}] {
    animation-name: ${slideRightAndFade};
  }
`;

export const HoverCardContent = forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<typeof Content>
>(({ sideOffset = 8, align = HoverCardAlignment.Start, ...props }, ref) => {
  return (
    <Portal>
      <StyledContent ref={ref} align={align} sideOffset={sideOffset} {...props} />
    </Portal>
  );
});
